import React from "react";

import { CircularProgress, Button } from "@material-ui/core";

export default function BreakButton(props) {
	let val = null;
	if (props.agentState === "BREAK" && props.breakType !== "JoinedConference" && !props.agentInConf) {
		val = "Back From Break";
	} else if (props.agentState === "READY") {
		val = "Ready";
	}
	return val ? (
		<Button variant="outlined" color="secondary" size="small" className={props.applyStyle} style={{ marginInlineEnd: "10px", textTransform: "capitalize", border: "2px solid" }} onClick={() => props.handleBreak()}>
			{val + " "}
			{props.breakLoading ? <CircularProgress size={22} style={{ verticalAlign: "middle", marginInlineStart: "8px" }} /> : ""}
		</Button>
	) : (
		""
	);
}
